import * as React from "react";

const IconUserFocused: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="currentColor"><path fill="currentColor" d="M7,8 C9.20937538,8 11,6.20906258 11,4 C11,1.79093742 9.20937538,0 7,0 C4.7906251,0 3,1.79093742 3,4 C3,6.20906258 4.7906251,8 7,8 Z M8.58437538,9.5 L5.4156251,9.5 C2.42531252,9.5 0,11.9250002 0,14.9156246 C0,15.5137501 0.485000134,15.9990629 1.08312511,15.9990629 L12.9175005,15.9990629 C13.515625,16 14,15.515625 14,14.9156246 C14,11.9250002 11.5749998,9.5 8.58437538,9.5 Z"/></svg>;
};

export default React.memo(IconUserFocused);
